import { render, staticRenderFns } from "./OfflineUniversityExam.vue?vue&type=template&id=05ea5e16"
import script from "./OfflineUniversityExam.vue?vue&type=script&lang=js"
export * from "./OfflineUniversityExam.vue?vue&type=script&lang=js"
import style0 from "./OfflineUniversityExam.vue?vue&type=style&index=0&id=05ea5e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports